<div *ngIf="showLoader" class="loading_style">
    <button type="button" class="bg-indigo-500 loading_screen" disabled>
        <img src="assets/img/loading.svg" class="ml-2 mx-2 text-white animate-spin">
        Processing...
    </button>
</div>
